import { CallEndedView } from "../features/call-ended/CallEndedView";

export const CallEndedPage = CallEndedView;
